import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { selectDimensions, useSelector } from '@bonanza-social/toolkit/state';
import { AnimatedCoinsEllipse } from '@bonanza-social/moonlight';
import { selectStatus } from '../../state/status/status.slice';
import { shouldShowAnimation } from './StatusProgressAnimation.utils';

function StatusProgressAnimation() {
  const status = useSelector(selectStatus);
  const prevStatus = useRef(status);
  const [showAnimation, setShowAnimation] = useState(false);
  const fromPoint = useSelector(selectDimensions('STATUS_HEADER_ITEM'));
  const toPoint = useSelector(selectDimensions('COIN_BALANCE_HEADER_ITEM'));

  const onAnimationFinish = useCallback(() => {
    setShowAnimation(false);
  }, []);

  useEffect(() => {
    if (showAnimation) {
      prevStatus.current = status;
    }
  }, [showAnimation, status]);

  useEffect(() => {
    setShowAnimation(
      (showAnimation) =>
        !showAnimation && shouldShowAnimation(status, prevStatus.current),
    );
  }, [status]);

  if (!showAnimation || !fromPoint || !toPoint) {
    return;
  }

  return (
    <AnimatedCoinsEllipse
      fromPoint={fromPoint}
      toPoint={toPoint}
      onAnimationFinish={onAnimationFinish}
    />
  );
}

export default memo(StatusProgressAnimation);
